import { call, put, takeEvery } from "redux-saga/effects";
import { khoaApi } from "../../../api/category/khoaApi";
import { IKhoa } from "../../../model/respone/category/IKhoa";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eKhoaActionIds,
  IKhoaActionTypes,
} from "../../action-types/category/IKhoaActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.khoa;
export function* khoaSaga(): any {
  yield takeEvery(eKhoaActionIds.LOAD_START, loadWorker);
  yield takeEvery(eKhoaActionIds.SAVE_START, saveWorker);
  yield takeEvery(eKhoaActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(khoaApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IKhoaActionTypes): any {
  let res: IBaseRespone = yield call(khoaApi.SelectAll);
  let payload = action.payload as IKhoa;

  if (payload.id_khoa > 0) {
    res = yield call(khoaApi.Update, payload);
  } else {
    payload = {
      ...payload,
      id_khoa_cu: 0,
      ma_dong_tui_thi: "",
      id_cb_nhap_ky_luat1: 0,
      id_cb_nhap_ky_luat: 0,
    };
    res = yield call(khoaApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IKhoaActionTypes): any {
  const res: IBaseRespone = yield call(
    khoaApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
